import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const ScreenCreatingAiStyles = styled(OnboardingPage)`
  .creating-ai-title {
    margin: 32px auto 40px;
  }

  .setting-up-subtitle {
    margin-bottom: 20px;
  }

  .setting-up-user-reviews {
    margin: 24px 0 0;
  }
`;
